<template>
  <TabView>

    <TabPanel header="Opis" v-if="item.long_desc" class="pt-s20 px-s15 text-t14 m_1200:text-t16">
      <div v-html="item.long_desc"></div>
    </TabPanel>

    <TabPanel header="Sastav" v-if="item.structure" class="pt-s20 px-s15 text-t14 m_1200:text-t16">
      <div v-html="item.structure"></div>
    </TabPanel>

    <TabPanel header="Održavanje" v-if="item.maintenance" class="pt-s20 px-s15 text-t14 m_1200:text-t16">
      <div v-html="item.maintenance"></div>
    </TabPanel>

    <TabPanel header="Više informacija" class="pt-s20 px-s15 text-t14 m_1200:text-t16">
      Uvoznik: {{ item.importer }}<br>
      Dobavljač: {{ item.supplier }}<br>
      Zemlja porekla: {{ item.country_of_origin }}
    </TabPanel>

  </TabView>
</template>

<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

export default {
  name: "ProductTabs",

  props: [
    'item',
  ],

  components: {
    TabView,
    TabPanel,
  },
}
</script>

<style scoped>
:deep(.p-tabview-nav){width:fit-content;border:1px solid #000;border-right:none}:deep(.p-tabview-nav li a){padding:10px 15px;font-size:14px}@media(min-width:1200px){:deep(.p-tabview-nav li a){font-size:16px}}:deep(.p-tabview-nav li a){border-right:1px solid #000}:deep(.p-tabview-nav li.p-highlight){background-color:#000;color:#fff}
</style>